import React, { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import "../InsigniaComponents/exclusivos.css"; // Import external styles
import { TbCardsFilled } from "react-icons/tb";
import { MdAttachMoney } from "react-icons/md";
import { FaUniversity } from "react-icons/fa";
import { FaBoxes } from "react-icons/fa";
import { HiWrenchScrewdriver } from "react-icons/hi2";

const benefits = [
    { Icon: TbCardsFilled, text: "Tarjetas informativas" },
    { Icon: MdAttachMoney, text: "Los mejores precios" },
    { Icon: FaUniversity, text: "Dirigido a estudiantes del TEC" },
    { Icon: FaBoxes, text: "Entrega inmediata" },
    { Icon: HiWrenchScrewdriver, text: "Totalmente personalizables" },
];

const KitsDescription = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("slide-in");
                    } else {
                        entry.target.classList.remove("slide-in");
                    }
                });
            },
            { threshold: 0.1 }
        );

        const element = containerRef.current;
        if (element) {
            observer.observe(element);
        }

        return () => {
            if (element) {
                observer.unobserve(element);
            }
        };
    }, []);

    return (
        <Box className="box-container" ref={containerRef}>
            {/* Centered Image */}
            <Box
                component="img"
                src="/images/kits.png"
                alt="Productos Insignia"
                className="centered-image"
            />

            <span className="kits-eyebrow" aria-hidden="true" />

            {/* Title and Description with responsive font sizes */}
            <Typography
                component="h1"
                className="title_kits"
                sx={{ fontSize: { xs: "2.5rem", md: "3.5rem" } }}
            >
                Kits
            </Typography>
            <Typography
                component="p"
                className="description"
                sx={{ fontSize: { xs: "1.4rem", md: "1.6rem" }, mx: "auto" }}
            >
                Con los kits personalizados de Volteon tendrás todo lo que necesitas para
                tus cursos de laboratorio. Diseñados con base en la lista de experimentos
                para brindar la mejor experiencia.
            </Typography>

            {/* Icons container */}
            <Box className="icons-container">
                {benefits.map(({ Icon, text }) => (
                    <Box className="benefit" key={text}>
                        <Box className="benefit-icon-badge">
                            <Icon />
                        </Box>
                        <Typography component="p">{text}</Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default KitsDescription;
